// function for live url of upload image
function multiRoundOff(params1, params2) {
  const newparms = parseFloat(params1);
  const newparms2 = parseFloat(params2);
  const total = newparms * newparms2;
  const subTotalFormatted = parseFloat(total).toFixed(4);
  return subTotalFormatted;
}
function addRoundOff(params1, params2) {
  const newparms = parseFloat(params1);
  const newparms2 = parseFloat(params2);
  const total = newparms + newparms2;
  const subTotalFormatted = parseFloat(total).toFixed(4);
  return subTotalFormatted;
}
function addRoundOffTripple(params1, params2, params3) {
  console.log(params1, params2, params3);
  const newparms = parseFloat(params1);
  const newparms2 = parseFloat(params2);
  const newparms3 = parseFloat(params3);

  const total = newparms + newparms2 + newparms3;
  console.log("total", total);
  const subTotalFormatted = parseFloat(total).toFixed(4);
  return subTotalFormatted;
}

function round_of_two(params1) {
  const round_of_value = parseFloat(params1).toFixed(2);
  return round_of_value;
}
function round_of_zero(params1) {
  const round_of_value = parseFloat(params1).toFixed(0);
  return round_of_value;
}
function round_of_four(params1) {
  const round_of_value = parseFloat(params1).toFixed(4);
  return round_of_value;
}
function convert_into_bags(params) {
  const converted_value = parseFloat(params) / 100;
  const converted_bags = Math.trunc(converted_value);
  return converted_bags;
}
function convert_into_cons(params) {
  console.log("params", params);

  const converted_value = parseFloat(params) / 100;

  const converted_bags = Math.trunc(converted_value);
  const float_part = Number((converted_value - converted_bags).toFixed(2));
  return float_part;
}
function usedYarn(params1, params2) {
  const newparms = parseFloat(params1);
  const newparms2 = parseFloat(params2);
  const total = newparms * newparms2;
  return total;
}
function produc(params1, params2) {
  const newparms = parseFloat(params1);
  const newparms2 = parseFloat(params2);
  const total = newparms * newparms2;
  return total;
}
function additionWithoutRound(params1, params2) {
  const newparms = parseFloat(params1);
  const newparms2 = parseFloat(params2);
  const total = newparms * newparms2;
  return total;
}
module.exports = {
  multiRoundOff,
  addRoundOff,
  addRoundOffTripple,
  round_of_two,
  round_of_zero,
  convert_into_bags,
  convert_into_cons,
  usedYarn,
  round_of_four,
  produc,
  additionWithoutRound,
};
